import React from 'react'
import { Radio as MaterialRadio } from '@material-ui/core'
import { SUMMER_SKY } from 'constants/colors'
import { RadioCheckedIcon, RadioIcon, RadioContainer } from './Radio.styles'
import { RadioProps } from './Radio.types'

function Radio({
  checked,
  disabled = false,
  onChange,
  color = SUMMER_SKY,
  ...rest
}: RadioProps) {
  return (
    <RadioContainer color={color}>
      <MaterialRadio
        checked={checked}
        checkedIcon={<RadioCheckedIcon color={color} />}
        icon={<RadioIcon />}
        onChange={onChange}
        aria-label="radio"
        disabled={disabled}
        {...rest}
      />
    </RadioContainer>
  )
}

export default Radio
